<nav class="navbar navbar-expand-md container-navbar">
  <ul class="navbar-nav container container-size navbar-custom">
    <button mat-button [routerLink]="['/main']">
      <fa-icon [icon]="faHome" class="mx-1"></fa-icon>
      <span> Home</span>
    </button>

    <button mat-button [routerLink]="['/hilfe']">
      <fa-icon [icon]="faQuestion" class="mx-1 header-text"></fa-icon>
      <span>Hilfe</span>
    </button>

    <button mat-button [matMenuTriggerFor]="menuInformation">
      <fa-icon [icon]="faInfo" class="mx-1 header-text"></fa-icon>
      <span>Informationen</span>
      <fa-icon [icon]="faCaretDown" class="mx-1 header-text"></fa-icon>
    </button>
    <mat-menu #menuInformation="matMenu">
      <a mat-menu-item [routerLink]="['/autoren-zitierhinweise']"
        >Autoren und Zitierhinweise</a
      >
      <a
        href="https://www.nationales-tierwohl-monitoring.de/projekt/projektteam/"
        target="_blank"
        mat-menu-item
        >Projektteam (ext. Link)</a
      >
      <a mat-menu-item (click)="downloadPdfAbkuerzung()"
        >Abkürzungsverzeichnis (
        <fa-icon
          [icon]="faDownload"
          class="mx-1 header-text download-icon"
        ></fa-icon>
        {{ abkuerzungsverzeichnis.endungText }}-Download
        {{ abkuerzungsverzeichnis.sizeString }})</a
      >
      <a mat-menu-item [routerLink]="['/quellen']">Quellenverzeichnisse</a>
      <a
        href="https://www.nationales-tierwohl-monitoring.de/"
        target="_blank"
        mat-menu-item
        >Infos zum Projekt Nationales Tierwohl-Monitoring (ext. Link)</a
      >
      <a mat-menu-item [routerLink]="['/foerderung']">Förderung</a>
      <a mat-menu-item [routerLink]="['/faq']">FAQ</a>
    </mat-menu>

    <!--
  
          <a class="dropdown-item" (click)="downloadPdfAbkuerzung()">
            Abkürzungsverzeichnis (<fa-icon
              [icon]="faDownload"
              class="mx-1 dropdown-icon-download download-info"
              (click)="downloadPdfAbkuerzung()"
            ></fa-icon>
            PDF-Download 200 KB)</a
          >  

-->
  </ul>
</nav>
